import './util/sentry';

import Vue from 'vue';
import VueRouter from 'vue-router';

import {
    AlertPlugin,
    BDropdown,
    BDropdownDivider,
    BDropdownItem,
    CarouselPlugin,
    CollapsePlugin,
    FormFilePlugin,
    FormRadioPlugin,
    FormTextareaPlugin,
    ModalPlugin,
    TabsPlugin,
} from 'bootstrap-vue';
import FormDatePicker from "./components/FormDatePicker.vue";

import directives from "./directives";

// vendor plugins
import {VueMasonryPlugin} from 'vue-masonry/src/masonry.plugin.js';
import VueSocialSharing from 'vue-social-sharing';
import Formoj from 'formoj';
import './cursus';

// own components
import components from './components';

// util/customs
import {focus} from "./util";
import dayjs from "dayjs";
import 'dayjs/locale/fr';

import './api';
// css
import 'swiper/dist/css/swiper.min.css';

dayjs.locale('fr');

// use vendor plugins
Vue.use(VueMasonryPlugin);
Vue.use(VueSocialSharing);
Vue.use(Formoj, {
    scrollOffset: 160, // offset the height of header
});


// bootstrap-vue
Vue.use(CarouselPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormFilePlugin);
Vue.use(CollapsePlugin);
Vue.use(ModalPlugin);
Vue.use(AlertPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(TabsPlugin);
Vue.component('b-dropdown', BDropdown);
Vue.component('b-dropdown-divider', BDropdownDivider);
Vue.component('b-dropdown-item', BDropdownItem);
// overridden date picker
Vue.component('b-form-datepicker', FormDatePicker);

Vue.use(VueRouter);

Vue.component('swiper', () => import(/* webpackChunkName: 'vue-swiper' */'vue-awesome-swiper').then(module => module.swiper));
Vue.component('swiper-slide', () => import(/* webpackChunkName: 'vue-swiper' */'vue-awesome-swiper').then(module => module.swiperSlide));



Object.keys(components).forEach((name) => {
    Vue.component(name, components[name]);
});

document.querySelectorAll('[data-vue]').forEach(el => {
    const app = new Vue({
        methods: {
            focus,
        },
        created() {
            // fix social links do not open on ios
            if(/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
                window.open = (href, target) => Object.assign(document.createElement('a'), { target, href }).click()
            }
            document.querySelector('.header')?.classList.remove('collapsed');
        },
        directives,
    });

    app.$mount(el);
});
